import { combineReducers } from '@reduxjs/toolkit';
import usersReducer from './reducers/businessReducer';
import categoryReducer from './reducers/categoryReducer';
import bookingReducer from './reducers/bookingReducer';

const reducers = combineReducers({
  users: usersReducer,
  category: categoryReducer,
  booking: bookingReducer
});

export default reducers;
